import { render } from "./navButtons.vue?vue&type=template&id=1e97b43e&scoped=true"
import script from "./navButtons.vue?vue&type=script&lang=js"
export * from "./navButtons.vue?vue&type=script&lang=js"

import "./navButtons.vue?vue&type=style&index=0&id=1e97b43e&scoped=true&lang=css"
import "./navButtons.vue?vue&type=style&index=1&id=1e97b43e&lang=css"

import exportComponent from "/var/www/clients/client2/web300/web/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e97b43e"]])

export default __exports__